import React from 'react';
import { StepProps } from '../types';
import { fetchAIReflection } from '../utils/ai';

const StepFinalComment: React.FC<StepProps> = ({ state, onUpdate, onNext, isActive }) => {
  const maxLength = 300;
  const currentLength = state.finalComment.length;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      onUpdate({ finalComment: value });
    }
  };

  const flipTheCoin = async ()=>{
    onNext();
    // Call AI
    try {
      const reflection = await fetchAIReflection(
        state.situation,
        state.options,
        state.finalComment
      );
      onUpdate({ aiReflection: reflection, aiStatus: 'success' });
      state.aiStatus="success";
    } catch (error) {
      onUpdate({ aiStatus: 'error' });
    }
  }

  return (
    <>
      <h2 className="step-title">One last thought</h2>
      <p className="step-subtitle">Anything you want to say before the flip?</p>
      <textarea
        value={state.finalComment}
        onChange={handleChange}
        placeholder="Optional thoughts..."
        rows={3}
        disabled={!isActive}
      />
      <div className="char-counter">
        {currentLength}/{maxLength}
      </div>
      {isActive && (
        <button
          className="btn"
          onClick={flipTheCoin}
        >
          Flip the coin
        </button>
      )}
    </>
  );
};

export default StepFinalComment;
